import type { FormatMetres } from "./types";

/**
 * `toLocaleString()` with no locale follows the BROWSER, not the app. A German
 * session on an en-US Chrome printed `6,006 m`, which a Kalkulator reads as six
 * point zero zero six metres. DIN 5008 is decimal comma, thousands dot — and a
 * number he misreads once makes every number on the screen suspect.
 */
export const formatMetres: FormatMetres = ({ value, language, fractionDigits }) =>
  value.toLocaleString(language?.startsWith("de") ? "de-DE" : "en-GB", {
    minimumFractionDigits: fractionDigits ?? 0,
    maximumFractionDigits: fractionDigits ?? 1,
  });
